package com.trevorwiebe.timesheet.core.domain.model

data class Customer(
    val id: String,
    val contactName: String,
    val companyName: String = "",
    val address: String = "",
    val phone: String = "",
    val emails: List<String> = emptyList(),
    val paymentTerms: String = "",
    val notes: String = "",
    val deleted: Boolean = false
)
